//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Filters from "./components/Filters.vue";
// import Sort from "./components/Sort.vue";
// import Query from "./components/Query.vue";
import Result from "./components/Result.vue";

export default {
  name: "DoctorSearch",
  data() {
    return {
      filtersVisible: false,
    }
  },
  computed: {
    toggleText() {
      return this.filtersVisible ? 'Hide Filters' : 'Show Filters';
    }
  },
  components: {
    // Sort,
    // Query,
    Result,
    Filters
  },
  method: {}
};
